import { BootResponse } from "./boot.types";

export const getBoot = async (
  baseUrl: string,
  bootLocation: string,
  onLoaded: (response: BootResponse) => string,
  onBadResponse: (response?: any) => void,
  onError: (error: any) => void
) => {
  try {
    const response = await fetch(`${baseUrl}/store/${bootLocation}/boot`, {});

    if (response.ok) {
      return onLoaded?.(await response.json()) as string;
    } else {
      onBadResponse?.(response);
    }
  } catch (error) {
    onError?.(error);
  }
};
